var _excluded = ["items", "size", "emphasis", "type", "iconColor", "iconVerticalCenter", "iconRightSpace", "reverseIconMobile"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var SmallDot = function SmallDot(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3"
  }));
};
SmallDot.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tick2 = function Tick2(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.552.707a1.185 1.185 0 0 1 1.586-.595 1.184 1.184 0 0 1 .596 1.585h.002l-6.44 13.354v.002a1.184 1.184 0 0 1-1.591.582 1.185 1.185 0 0 1-.582-1.59l-.009.016L10.551.707h.001ZM4 12.638V5.977a1.185 1.185 0 0 1 1.198-1.198 1.185 1.185 0 0 1 1.197 1.198v1.69L4 12.638Z"
  }));
};
Tick2.defaultProps = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tick = function Tick(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 1.33 5.057 10 0 5.098l1.374-1.33 3.684 3.57L12.626 0 14 1.33z"
  }));
};
Tick.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
};
import breakpoint from "../../../utils/breakpoint";
import space, { spaceFactor } from "../../../utils/space";
import unit from "../../../utils/unit";
import IconAtm from "../../atoms/IconAtm";
import TextAtm from "../../atoms/TextAtm";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
export var defaultProps = {
  emphasis: "high"
};
var sizes = {
  small: {
    textTypography: "small1",
    numberTypography: "small3"
  },
  medium: {
    textTypography: "medium1_h",
    numberTypography: "medium3_h"
  },
  big: {
    textTypography: "big1",
    numberTypography: "big3"
  }
};
var types = {
  dot: SmallDot,
  tick: Tick,
  tick2: Tick2
};
var iconSizeSpace = 2;
var iconGutterSpace = 1.5;
var OrderedList = styled.ol.withConfig({
  componentId: "sc-i1w2bn-0"
})(function (_ref) {
  var $size = _ref.$size,
    $emphasis = _ref.$emphasis,
    $onColor = _ref.$onColor;
  var numberTypography = sizes[$size].numberTypography;
  return css(["counter-reset:counter;li{counter-increment:counter;&::before{", ";content:counter(counter) \".\";margin-right:", ";}}"], cssTextAtm({
    typography: numberTypography,
    emphasis: $emphasis,
    onColor: $onColor
  }), space(1));
});
var ListItem = styled.li.withConfig({
  componentId: "sc-i1w2bn-1"
})(function (_ref2) {
  var $type = _ref2.$type,
    $iconVerticalCenter = _ref2.$iconVerticalCenter,
    $reverseIconMobile = _ref2.$reverseIconMobile;
  return css(["display:flex;", " ", " ", " &:last-child{margin-bottom:0;}", ""], $iconVerticalCenter && css(["align-items:center;"]), $type === "dot" && css(["margin-bottom:", ";"], space(1)), $type === "tick" && css(["margin-bottom:", ";"], space(1.5)), $reverseIconMobile && css(["", "{flex-direction:row-reverse;justify-content:space-between;}"], breakpoint("small", "medium")));
});
var StyledIconAtm = styled(IconAtm).withConfig({
  componentId: "sc-i1w2bn-2"
})(function (_ref3) {
  var $typography = _ref3.$typography,
    $iconRightSpace = _ref3.$iconRightSpace,
    $reverseIconMobile = _ref3.$reverseIconMobile,
    theme = _ref3.theme;
  var itemTypographyLineHeightSpace = theme.typography[$typography].lineHeightSpace;
  return css(["flex-shrink:0;margin-top:", ";margin-right:", ";", ""], unit((itemTypographyLineHeightSpace - iconSizeSpace) * spaceFactor / 2), space($iconRightSpace || iconGutterSpace), $reverseIconMobile && css(["", "{margin-right:0;margin-left:", ";}"], breakpoint("small", "medium"), space($iconRightSpace || iconGutterSpace)));
});
function ListMol(_ref4) {
  var items = _ref4.items,
    size = _ref4.size,
    _ref4$emphasis = _ref4.emphasis,
    emphasis = _ref4$emphasis === void 0 ? defaultProps.emphasis : _ref4$emphasis,
    type = _ref4.type,
    iconColor = _ref4.iconColor,
    iconVerticalCenter = _ref4.iconVerticalCenter,
    iconRightSpace = _ref4.iconRightSpace,
    reverseIconMobile = _ref4.reverseIconMobile,
    restProps = _objectWithoutProperties(_ref4, _excluded);
  var onColor = useContext(OnColorContext);
  var textTypography = sizes[size].textTypography;
  var listItems = /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
    return (
      /*#__PURE__*/
      /* eslint-disable react/no-array-index-key */
      React.createElement(ListItem, {
        $type: type,
        $iconVerticalCenter: iconVerticalCenter,
        $reverseIconMobile: reverseIconMobile,
        key: "ListItem-".concat(index)
      }, type !== "number" && /*#__PURE__*/React.createElement(StyledIconAtm, {
        icon: types[type],
        sizeSpace: 2,
        color: iconColor,
        $typography: textTypography,
        $iconRightSpace: iconRightSpace,
        $reverseIconMobile: reverseIconMobile
      }), /*#__PURE__*/React.createElement(TextAtm, {
        typography: textTypography,
        emphasis: emphasis
      }, item))
    );
  }));
  if (type === "number") {
    return /*#__PURE__*/React.createElement(OrderedList, _extends({
      $emphasis: emphasis,
      $size: size,
      $onColor: onColor
    }, restProps), listItems);
  }
  return /*#__PURE__*/React.createElement("ul", restProps, listItems);
}
export default ListMol;